import { render } from "./profileSearch.vue?vue&type=template&id=b07457c4"
import script from "./profileSearch.vue?vue&type=script&lang=js"
export * from "./profileSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__